module.exports = __webpack_public_path__ + "img/buyerEN.71ea1b44.png";